export default __webpack_public_path__ + "static/media/video-image.8959fac5.svg";